import React from 'react';

export const SubLabel = ({ text }) => {
  return (
    <label className="Form__SubLabel">
      {text}
    </label>
  )
}

